import { Request } from '../request';

// 邮箱验证接口参数
interface EmailCheckParams {
    email: string;
}

// 邮箱验证返回数据
interface EmailCheckResponse {
    exists: boolean;
    message?: string;
}

/**
 * 检查邮箱是否已存在账号
 * @param email 邮箱地址
 * @returns Promise<EmailCheckResponse>
 */
export const checkEmailExists = async (email: string): Promise<{
    success: boolean;
    data?: EmailCheckResponse;
    error?: string;
}> => {
    const response = await Request.post<EmailCheckParams>({
        url: 'api/auth/check-email',
        params: { email },
        disableErrorNote: true, // 禁用默认错误提示，由组件自己处理
    });

    return response;
};

/**
 * 验证邮箱格式
 * @param email 邮箱地址
 * @returns boolean
 */
export const validateEmailFormat = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
